import { createVNode as c, mergeProps as l } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/AccountFilled.js";
import n from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return c(n, l(e, {
    icon: i
  }), null);
};
t.displayName = "AccountFilled";
t.inheritAttrs = !1;
export {
  t as default
};
